<template>
  <div class="diseaseType">
    <Search :title="chame">
      <div class="summary">
        <div class="summary_box">
          <div>
            <p><i class="iconfont iconyuan high"></i>高风险：</p>
            <span>{{ quantity.high }} 项</span>
          </div>
          <div>
            <p><i class="iconfont iconyuan higher"></i>较高风险：</p>
            <span>{{ quantity.higher }} 项</span>
          </div>
          <div>
            <p><i class="iconfont iconyuan general"></i>一般风险：</p>
            <span>{{ quantity.normal }} 项</span>
          </div>
          <div>
            <p><i class="iconfont iconyuan lower"></i>较低风险：</p>
            <span>{{ quantity.lower }} 项</span>
          </div>
          <div>
            <p><i class="iconfont iconyuan low"></i>低风险：</p>
            <span>{{ quantity.low }} 项</span>
          </div>
        </div>
      </div>
      <div class="box">
        <div v-if="gdb3">
          <van-cell v-for="(item,index) in diseaseTypeData" :key="index" :title="item.name" is-link @click="$router.push({path: '/diseaseInfo/' + item.id + '/' + item.type})">
            <template slot="default">
              <span v-if="item.conclusion === 5" class="high">高风险</span>
              <span v-else-if="item.conclusion === 4" class="higher">较高风险</span>
              <span v-else-if="item.conclusion === 3" class="general">一般风险</span>
              <span v-else-if="item.conclusion === 2" class="lower">较低风险</span>
              <span v-else-if="item.conclusion === 1" class="low">低风险</span>
            </template>
          </van-cell>
        </div>
       <div v-if="gdb2">
         <van-cell v-for="(item,index) in diseaseTypeData" :key="index" :title="item.chname" is-link @click="$router.push({path: '/diseaseInfo/' + item.itemid + '/' + (chame === '肿瘤' ? 'tumour' : 'disease')})">
           <template slot="default">
             <span class="high" v-if="item.conclusion === '高风险'">{{ item.conclusion }}</span>
             <span class="low" v-if="item.conclusion === '低风险'">{{ item.conclusion }}</span>
             <span class="general" v-if="item.conclusion === '一般风险'">{{ item.conclusion }}</span>
             <span class="higher" v-if="item.conclusion === '较高风险'">{{ item.conclusion }}</span>
             <span class="lower" v-if="item.conclusion === '较低风险'">{{ item.conclusion }}</span>
           </template>
         </van-cell>
       </div>
      </div>
    </Search>
  </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'diseaseType',
  components: {
    Search
  },
  data () {
    return {
      gdb2: false,
      gdb3: false,
      chame: this.$route.params.id,
      quantity: {},
      diseaseTypeData: []
    }
  },
  methods: {
    getDiseaseItems () {
      this.util.get(this.api.disease_items + '?system=' + this.chame, '', (success) => {
        this.quantity = success.quantity
        this.diseaseTypeData = success.items
        this.util.setLS('paginationData', success.items)
      })
    },
    // gdb2
    getDiseaseSystemInfo () {
      this.util.get1(this.api.diseaseSystemInfo + '?system=' + this.chame, '', (success) => {
        this.quantity.high = success.high
        this.quantity.higher = success.higher
        this.quantity.low = success.low
        this.quantity.lower = success.lower
        this.quantity.normal = success.normal
        this.diseaseTypeData = success.list
      })
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
      this.getDiseaseItems()
    } else {
      this.gdb2 = true
      this.getDiseaseSystemInfo()
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .summary {
    background-color: #fff;
    padding: pxToRem(30px) pxToRem(60px);

    .summary_box {
      padding: pxToRem(20px) pxToRem(50px);
      color: #606062;
      background-color: #f5f5f7;
      border-radius: 12px;

      div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        letter-spacing: 1px;
        margin: pxToRem(3px) 0;

        span {
          color: #323233;
          font-weight: 600;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/disease/diseaseType.vue